/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEXPERIENCE= createAsyncThunk(
  "updateExperience/updateExperience",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateExperienceSlice = createSlice({
  name: "updateExperienceSlice",
  initialState: {
    updateExperience: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateExperience: (state) => {
        state.updateExperience.loading = false
        state.updateExperience.error = false
        state.updateExperience.data = []
        state.updateExperience.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEXPERIENCE.fulfilled, (state, action) => {
      state.updateExperience = {
        ...state.updateExperience,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEXPERIENCE.pending, (state, action) => {
      state.updateExperience = {
        ...state.updateExperience,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEXPERIENCE.rejected, (state, action) => {
      state.updateExperience = {
        ...state.updateExperience,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateExperienceAction = {
    UPDATEXPERIENCE,
};

export { updateExperienceAction };
export default updateExperienceSlice.reducer;
export const {setInitialStateOfupdateExperience} = updateExperienceSlice.actions